export const ModifyPlayerSelect = {
  name: "player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "player.select",
  showOn: [{ state: "editState", value: "player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
        excludeOtherEvents: false,
        excludeFrom: "main",
        calculateOnCourt: "after",
      },
      actionGroups: [
        {
          actions: [
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            { action: "calculateOnCourt" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
